import { REACT_APP_UI_URL } from 'constants/config';
import { getChildrenNames } from '../../connect-card-widget/utils';
import FIELD_TYPE from '../constants/field-types';

export const getAnswerValueString = (answer, questionType) => {
  switch (questionType) {
    case FIELD_TYPE.NAME:
      return answer.firstName + ' ' + answer.lastName;
    case FIELD_TYPE.ADDRESS:
      return Object.values(answer).join(', ');
    case FIELD_TYPE.BOOLEAN:
      return answer ? 'Yes' : 'No';
    case FIELD_TYPE.CHOICE:
      return Array.isArray(answer)
        ? answer.map((i) => i.label).join(', ')
        : answer.label;
    case FIELD_TYPE.ADD_MEMBERS:
      return getChildrenNames(answer);
    case FIELD_TYPE.SCHEDULER:
      return answer.datetime;
    default:
      return answer;
  }
};

export const getConnectCardUrl = (cc) => {
  if (cc.redirect?.qr_code_text) {
    return cc.redirect.qr_code_text;
  }
  return `${REACT_APP_UI_URL}/connect-cards/${cc.hash}`;
};

export const getConnectPageUrl = (cp) => {
  if (cp.redirect?.qr_code_text) {
    return cp.redirect.qr_code_text;
  }
  return `${REACT_APP_UI_URL}/connect-pages/${cp.hash}`;
};

export const getCardCompletionRate = (card) => {
  let card_completion_rate;
  if (card.card_visits < 1 || card.card_completions < 1) {
    card_completion_rate = 0;
  } else {
    card_completion_rate = (card.card_completions / card.card_visits) * 100;
  }
  return +card_completion_rate.toFixed(0);
};

export const templateQuestions = {
  basic: [],
  extended: [
    {
      question_label: 'What is your address?',
      question_type: 'address',
      question_enabled: '1',
      sort_order: 3,
    },
  ],
  ext_family: [
    {
      question_label: 'What is your address?',
      question_type: 'address',
      question_enabled: '1',
      sort_order: 3,
    },
    {
      question_label: 'Add Family Members',
      question_type: 'add_member',
      question_enabled: '1',
      sort_order: 4,
    },
  ],
};
